import React from "react";

const SvgBBiconsESG = (props) => (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
      <path d="M143.7,136.8c9.4-5.2,15.6-8.6,16.7-9.2c1.1-0.6,2.2-1.2,3.2-1.7c-0.9-1.2-2.5-2.1-4.8-2.2c-2.7-0.1-6.3,0.8-10.7,3.4
			c-0.7,0.4-5.5,3-9.5,5.2c0.5,1.1,0.8,2.3,0.8,3.7c0,1.2-0.3,2.4-0.7,3.5C140.9,138.3,142.6,137.4,143.7,136.8z"/>
		<path d="M147.3,124.4c-0.7-0.2-1.4-0.4-2.2-0.4c-2.7-0.1-6.3,0.8-10.7,3.4c-0.1,0-0.8,0.4-1.1,0.6c1.4,0.4,2.7,1.2,3.7,2.1
			c0.1-0.1,0.1-0.2,0.2-0.2c0.5-0.3,6.2-3.4,6.7-3.7c1.6-0.9,2.4-1.3,2.7-1.5C146.9,124.6,147.1,124.5,147.3,124.4z"/>
		<path d="M43.3,114H28.6c-3.8,0-6.8,3-6.8,6.8v32.7c0,3.7,3,6.8,6.8,6.8h14.8c3.8,0,6.8-3,6.8-6.8v-32.7
			C50.1,117,47.1,114,43.3,114z M36,155.4c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1
			C41.1,153.1,38.8,155.4,36,155.4z"/>
		<path d="M161.8,130c-2,1.1-25.9,14.6-25.9,14.6c-2.9,0-5.7,0-5.7,0s-22.1,0-28.6,0c-2.9,0-2.9-2.9,0-2.9h28.6
			c8.6,0,8.6-11.4,0-11.4c-2.9,0-25.7-2.9-31.5-5.7c-5.7-2.9-17.2-8.6-28.6-8.6c-11.4,0-17.2,2.9-17.2,2.9v34.3v2.9
			c0,0,56.2,8.3,80.1,8.6c6.4,0.1,43.1-28.9,43.1-28.9C181.7,130.4,176,121.8,161.8,130z"/>
		<path d="M151.9,55.1c1.5,1.7,1.5,4.4-0.2,6l-47.7,47c12.1-1.5,32.5-6,46.5-20.1c16.9-16.9,20-42.9,20.6-52.7
			c-9.8,0.6-35.8,3.8-52.7,20.6c-13.8,13.8-18.4,33.8-20,45.9l47.7-47C147.8,53.3,150.4,53.3,151.9,55.1z"/>
		<path d="M89,91.7L68.1,70.8C67,69.7,67,68,68.1,67c1.1-1.1,2.8-1.1,3.8,0L93,88.1c-0.1-4-1.2-18.6-10.9-28.3
			c-11-11-28.6-10.9-29.3-10.9c-1.5,0-2.6,1.2-2.7,2.7c0,0.7-0.1,18.3,10.9,29.3C70.4,90.3,84.6,91.5,89,91.7z"/>
      </g>
    </svg>
);

export default SvgBBiconsESG;